import { DirectDebitPaymentOrderDTO } from '@/api/direct-debit';

export default {
  post(paymentOrder: DirectDebitPaymentOrderDTO) {
    return paymentOrder;
  },
};
